// @ts-nocheck
import { useDispatch, useSelector } from "react-redux";
import { useContext, useEffect, useState } from "react";
import { setFileversionIdAndNodeOffsetIdMap } from "../actions/common";
import { HoopsViewerContext } from "@Components/Viewer/ViewerContext";
import _ from "lodash";
import { getFileversionIdFromAwsfilename } from "./cubeViewHelper";

const useFileVersionIdAndNodeOffsetIdMap = (fileVersionId: string) => {
  const dispatch = useDispatch();
  const filesData = useSelector((state) => state.filesData);
  const { isModelStructureReady } = useContext(HoopsViewerContext);

  const [mapper, setMapper] = useState<{ [key: string]: string }>({});

  useEffect(() => {
    const fetchFileVersionMapping = () => {
      const newMapper: { [key: string]: string } = {};
      const absoluteNode = hwv.model.getAbsoluteRootNode();
      const modelFileNodes = hwv.model.getNodeChildren(absoluteNode);

      modelFileNodes.forEach((node: any) => {
        const awsFilename = hwv.model.getModelFileNameFromNode(node);
        const fileVersionIdFromAws = getFileversionIdFromAwsfilename(awsFilename);
        if (fileVersionIdFromAws) {
          const nodeOffset = hwv.model.getNodeIdOffset(node);
          newMapper[fileVersionIdFromAws] = nodeOffset;
        }
      });

      dispatch(setFileversionIdAndNodeOffsetIdMap(newMapper));
      setMapper(newMapper);
    };

    let fileVersions = [];
    if (filesData[fileVersionId] && filesData[fileVersionId].resourceType == "RESOURCE_TYPE_MERGED_FILE") {
      fileVersions = filesData[fileVersionId].sourceFileVersionId
        .filter((file) => !file.isDeleted)
        .map((file) => file.id);
    } else {
      fileVersions = [fileVersionId];
    }
    if (
      isModelStructureReady &&
      !fileVersions.every((val) => Object.hasOwn(mapper, val)) &&
      fileVersions.every((val) => Object.hasOwn(filesData, val))
    ) {
      fetchFileVersionMapping();
    }
  }, [fileVersionId, filesData, mapper, isModelStructureReady]);

  return mapper;
};

export default useFileVersionIdAndNodeOffsetIdMap;
